import React from 'react';
import PropTypes from 'prop-types';

const POIInfo = (props) => {
  let POIType = props._type === 'attraction' ? 'things to do' : props._type;

  return (
    <div>
      <span className="sk-hits-list-hit__type" dangerouslySetInnerHTML={{__html: POIType}}></span>
      <h2 className="sk-hits-list-hit__title" dangerouslySetInnerHTML={{__html: props._source.name}}></h2>
    </div>
  );
};

POIInfo.propTypes = {
  _type: PropTypes.string.isRequired,
  _source: PropTypes.shape({
    name: PropTypes.string.isRequired
  })
};

export default POIInfo;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POIInfo.jsx